module.exports = __webpack_public_path__ + "img/maximize.214efb45.svg";